// highchartsTheme.ts
export const lightTheme = {
  colors: ['#1976d2', '#ef6c00', '#2e7d32', '#9c27b0', '#00838f', '#c62828'],
  chart: { backgroundColor: '#ffffff' },
  title: { style: { color: '#111' } },
  xAxis: {
    lineColor: '#e0e0e0',
    tickColor: '#e0e0e0',
    gridLineColor: '#f0f0f0',
    labels: { style: { color: '#333' } },
    crosshair: { color: '#9e9e9e', width: 1 },
  },
  yAxis: {
    gridLineColor: '#f0f0f0',
    labels: { style: { color: '#333' } },
    title: { style: { color: '#333' } },
  },
  legend: {
    itemStyle: { color: '#333' },
    itemHoverStyle: { color: '#000' },
  },
  tooltip: {
    backgroundColor: 'rgba(255,255,255,0.98)',
    borderColor: '#ddd',
    style: { color: '#111' },
  },
  plotOptions: {
    series: {
      states: { inactive: { opacity: 1 } }, // keep your "no dimming"
      dataLabels: { color: '#333' },
    },
    xrange: {
      borderColor: '#bdbdbd',
    },
  },
};

export const darkTheme = {
  colors: ['#90caf9', '#ffb74d', '#81c784', '#ce93d8', '#80deea', '#ef9a9a'],
  chart: { backgroundColor: '#0f1115' },
  title: { style: { color: '#e6e6e6' } },
  xAxis: {
    lineColor: '#2a2f3a',
    tickColor: '#2a2f3a',
    gridLineColor: '#1c2028',
    labels: { style: { color: '#c7c7c7' } },
    crosshair: { color: '#616161', width: 1 },
  },
  yAxis: {
    gridLineColor: '#1c2028',
    labels: { style: { color: '#c7c7c7' } },
    title: { style: { color: '#c7c7c7' } },
  },
  legend: {
    itemStyle: { color: '#c7c7c7' },
    itemHoverStyle: { color: '#fff' },
  },
  tooltip: {
    backgroundColor: 'rgba(22,24,30,0.98)',
    borderColor: '#2a2f3a',
    style: { color: '#e6e6e6' },
  },
  plotOptions: {
    series: {
      states: { inactive: { opacity: 1 } },
      dataLabels: { color: '#c7c7c7' },
    },
    xrange: {
      borderColor: '#3a3f4a',
    },
  },
};
